let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ovfh")).then(() => parcelRequire('hnu5D'));